import { trackCustomEvent } from './track';

export const trackAuthLoginAttempted = (): void => {
  trackCustomEvent('auth_login_attempted');
};

export const trackAuthLoginSuccess = (): void => {
  trackCustomEvent('auth_login_success');
};

export const trackAuthLoginFailed = (errorType: string): void => {
  trackCustomEvent('auth_login_failed', { error_type: errorType });
};

export const trackAuthRegisterAttempted = (): void => {
  trackCustomEvent('auth_register_attempted');
};

export const trackAuthRegisterSuccess = (): void => {
  trackCustomEvent('auth_register_success');
};

export const trackAuthRegisterFailed = (errorType: string): void => {
  trackCustomEvent('auth_register_failed', { error_type: errorType });
};

export const trackInvoiceCreateStarted = (): void => {
  trackCustomEvent('invoice_create_started');
};

export const trackInvoiceCreateSuccess = (invoiceId: string): void => {
  trackCustomEvent('invoice_create_success', { invoice_id: invoiceId });
};

export const trackInvoiceCreateFailed = (errorType: string): void => {
  trackCustomEvent('invoice_create_failed', { error_type: errorType });
};

export const trackWithdrawalCreateStarted = (): void => {
  trackCustomEvent('withdrawal_create_started');
};

export const trackWithdrawalCreateSuccess = (withdrawalId: string): void => {
  trackCustomEvent('withdrawal_create_success', { withdrawal_id: withdrawalId });
};

export const trackWithdrawalCreateFailed = (errorType: string): void => {
  trackCustomEvent('withdrawal_create_failed', { error_type: errorType });
};

export const trackReferralCodeCopied = (): void => {
  trackCustomEvent('referral_code_copied');
};

export const trackReferralCodeRefreshed = (): void => {
  trackCustomEvent('referral_code_refreshed');
};
